import React, { useEffect, useState } from "react";
import "./styles.scss";
import {
  useCreateFuelTypeDataMutation,
  useDeleteFuelTypeInfoMutation,
  useGetAllFuelTypeDataQuery,
  useGetThemeDataQuery,
} from "../../../Services/vehicle/Vehicle";
import { toast } from "react-toastify";
import EditFuelType from "./EditFuelType";
import { Box, IconButton, Modal, Typography } from "@mui/material";
import { GridCloseIcon } from "@mui/x-data-grid";
import DeleteModal from "../DeleteModal";
import useThemeColors from "../ThemeColors";
import { capitalizeFirstLetter } from "../../../components/reusableComponent/CapitalLetter";

interface IPROPS {
  setLiftingName: any;
}
const ITEMS_PER_PAGE = 20;
const FuelType: React.FC<IPROPS> = ({ setLiftingName }) => {
  const [fuelType, setFuelType] = useState("");
  const [fuelTableData, setFuelTableData] = useState([]);
  const [vehicleTransport, setVehicleTransport] = useState([]);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [storedData, setStoredData] = useState();
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalCount] = useState(0);
  const { data: themeData } = useGetThemeDataQuery({});

  const name = "Vehicle Information";
  const totalPages = Math.ceil(totalItems / ITEMS_PER_PAGE);
  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = Math.min(startIndex + ITEMS_PER_PAGE, totalItems);
  useEffect(() => {
    setLiftingName(name);
  }, [setLiftingName]);

  const [createVehicleTrigger] = useCreateFuelTypeDataMutation();
  const {
    data: fuelData,
    status,
    refetch,
    isLoading,
  } = useGetAllFuelTypeDataQuery({
    page: currentPage,
    page_size: ITEMS_PER_PAGE
  });
  const [deleteTrigger] = useDeleteFuelTypeInfoMutation();

  useEffect(() => {
    if (fuelData) {
      setFuelTableData(fuelData?.results || []);
      setTotalCount(fuelData?.count || 0);
    }
  }, [fuelData]);

  const createVehicleDataHandler = async () => {
    const obj = {
      type: fuelType,
    };

    try {
      const response: any = await createVehicleTrigger(obj);

      if (response?.data) {
        toast.success("Data added successfully");
        setFuelType("");
        refetch();
      } else if (response?.error) {
        const errorData = response.error?.data;

        if (errorData?.type?.length > 0) {
          toast.error(errorData.type[0]); // show specific error for "type"
        } else if (errorData?.non_field_errors?.length > 0) {
          toast.error(errorData.non_field_errors[0]);
        } else if (errorData?.detail) {
          toast.error(errorData.detail);
        } else {
          toast.error("Unable to add vehicle data");
        }
      }
    } catch (error) {
      toast.error("An unexpected error occurred");
    }
  };

  const editHandler = (vehicle) => {
    setOpenEditModal(true);
    setStoredData(vehicle);
  };

  const closeModal = () => {
    setOpenEditModal(false);
    setOpenDeleteModal(false);
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "40%",
    overflow: "scroll",
    bgcolor: "background.paper",
    border: "1px solid transparent",
    boxShadow: 2,
    borderRadius: "5px",
    p: 4,
  };
  // const themeColors = {
  //     purple: "#7E57C2",
  //     orange: "#F25D21",
  //     blue: "#1976D2",
  //     green: "#388E3C",
  // };

  // const selectedTheme = themeData?.selected_theme || "white";
  // const themeColor = themeColors[selectedTheme];

  const deleteHandler = (vehicle) => {
    setStoredData(vehicle);
    setOpenDeleteModal(true);
  };
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      // Ideally trigger a data fetch here if paginated server-side
    }
  };

  const {
    selectedColor,
    selectedBackgroundColor,
    selectedBorderColor,
    selectedButtonBackgoundColors,
    selectedButtonColors,
  } = useThemeColors();
  return (
    <div className="vehicle-info-cont">
       <div className="workshops-container">
      <div
        className="vehicle-info-middle"
        style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px` }}
      >
        <div className="vehicle-info-middle-heading">Add Fuel Type</div>
        <div>
          <div
            className="vehicle-info"
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "10px",
            }}
          >
            <div
              style={{
                width: "100%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <p className="vehicle-class">
                <span
                  className="required"
                  style={{ paddingLeft: "10px", fontFamily: "karbon-medium" }}
                >
                  Fuel Type
                </span>
                <span>
                  <input
                    style={{
                      borderRadius: "20px",
                      background: "#FCFCFC",
                      fontFamily: "karbon-medium",
                    }}
                    placeholder="Fuel Type"
                    className="form-control"
                    type="text"
                    onChange={(e) => setFuelType(e.target.value)}
                    value={fuelType}
                  />
                </span>
              </p>
            </div>

            <div style={{ display: "flex", justifyContent: "end" }}>
              <button
                onClick={createVehicleDataHandler}
                disabled={!fuelType.trim()}
                style={{
                  background: !fuelType.trim()
                    ? "#F7D3C5"
                    : `${selectedButtonBackgoundColors}`,

                  color: `${selectedButtonColors}`,
                  border: "none",
                  padding: "10px 20px",
                  borderRadius: "20px",
                  fontSize: "15px",
                  cursor: !fuelType.trim() ? "not-allowed" : "pointer",
                }}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="vehicle-info-bottom mt-10"
        style={{ boxShadow: `${selectedColor}80 1px 1px 10px 1px` }}
      >
        <div className="vehicle-info-bottom-heading">Fuel Types</div>
        <table className="vehicle-info-bottom-table">
          <thead className="thead">
            <tr className="tr">
              <td>Sr.No.</td>
              <td>Name</td>
              <td style={{ padding: "0 20px" }}>Action</td>
              {/* <td>Model</td>
                      <td>Fuel type</td> */}
            </tr>
          </thead>
          <tbody className="table-body">
            {fuelTableData?.map((vehicle, index) => (
              <tr
                className="table-body-tr"
                style={{ background: index % 2 !== 0 ? "#FFF1EC" : "white" }}
              >
                <td
                  style={{
                    // padding: "10px 16px",
                    borderRadius: "40px",
                  }}
                >
               {(currentPage - 1) * ITEMS_PER_PAGE + index + 1}

                </td>
                <td
                  style={{
                    // padding: "10px 16px",
                    borderRadius: "40px",
                  }}
                >
                  {capitalizeFirstLetter(vehicle?.type)}
                </td>
                <td
                  style={{
                    display: "flex",
                    gap: "10px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <span onClick={() => editHandler(vehicle)}>
                    <i
                      className="bi bi-pencil"
                      style={{ fontSize: "20px", cursor: "pointer" }}
                    ></i>
                  </span>
                  {/* <span onClick={() => deleteHandler(vehicle)}>
                    <i
                      className="bi bi-trash3"
                      style={{ fontSize: "20px", cursor: "pointer" }}
                    ></i>
                  </span> */}
                </td>
                {/* <td>{vehicle?.model}</td>
                  <td>{vehicle?.fuel_type}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="pagination-footer mb-10">
        <div className="pagination-info">
          Showing {startIndex + 1} - {endIndex} of {totalItems}
        </div>

        <div className="pagination-controls">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-btn"
          >
            Prev
          </button>

          {/* Always show exactly 5 page numbers, centered around current page */}
          {Array.from(
            { length: Math.min(5, totalPages) },
            (_, i) => {
              // Calculate the first page to show (ensuring we always show 5 if possible)
              let firstPage = Math.max(1, Math.min(
                currentPage - 2,  // Try to center current page
                totalPages - 4    // But don't go past total pages - 4
              ));

              const pageNum = firstPage + i;

              return (
                <button
                  key={pageNum}
                  onClick={() => handlePageChange(pageNum)}
                  className={`pagination-btn ${pageNum === currentPage ? 'active' : ''}`}
                  style={{
                    display: pageNum > totalPages ? 'none' : 'inline-block',
                    margin: '0 2px',
                    minWidth: '32px',
                    textAlign: 'center'
                  }}
                >
                  {pageNum}
                </button>
              );
            }
          )}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-btn"
          >
            Next
          </button>
        </div>
      </div>

      {/* <div
                className="vehicle-info-top"
                style={{ display: "flex", justifyContent: "center" }}
            >
                <p className="vehicle-detail-buttons">
                    <span
                        style={{
                            color: themeColor,
                            border: `1px solid ${themeColor}`,
                        }}
                    >
                        Cancel
                    </span>
                    <span
                        onClick={createVehicleDataHandler}
                        style={{ background: themeColor }}
                    >
                        Save
                    </span>
                </p>
            </div> */}
            </div>
      <Modal
        open={openEditModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Box sx={{ ...style, position: "absolute" }}>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          ></Typography>

          <Box>
            <EditFuelType
              closeModal={closeModal}
              refetchingData={refetch}
              storedData={storedData}
            />
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openDeleteModal}
        onClose={closeModal}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
        BackdropProps={{
          style: {
            backgroundColor: "rgba(0, 0, 0, 0.2)",
          },
        }}
      >
        <Box sx={{ ...style, position: "absolute" }}>
          <IconButton
            aria-label="close"
            onClick={closeModal}
            sx={{
              position: "fixed",
              top: 16,
              right: 16,
              zIndex: 1301,
              background: "white",
            }}
          >
            <GridCloseIcon />
          </IconButton>
          <Typography
            id="modal-title"
            variant="h6"
            component="h2"
            sx={{ mb: 2 }}
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          ></Typography>

          <Box>
            <DeleteModal
              closeModal={closeModal}
              refetchingData={refetch}
              storedData={storedData}
              trigger={deleteTrigger}
              setTableData={setFuelTableData}
              fieldsData={fuelTableData}
            />
          </Box>
        </Box>
      </Modal>
    </div>
  );
};

export default FuelType;
